import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  Button,
  Typography,
  Grid,
  Tab,
  Tabs,
  TextField,
  DialogActions,
  ButtonGroup,
  Checkbox,
  FormControlLabel,
  Divider,
  Box,
  InputAdornment,
  Autocomplete,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";

import { getDocumentoVariables } from "../../../../../containers/smartForms/components/helper";
import { language } from "../../../../../language";
import {
  escape,
  getUniqueDocumentServiceFields,
  unescape,
} from "../../../../../util/camundaPropertiesPanelUtils";
import GenericModal from "../../../../modal-closebtn/index";
import Pagination from "../../../../Pagination";
import GenericSnackbar from "../../../../snackbar/generic-snackbar";

const TextFieldAutocompleteStyled = styled(TextField)(({ theme }) => ({
  "& .MuiInputLabel-root": {
    color: "#164194", // label padrão
  },
  "& label.Mui-focused": {
    color: "#164194", // label em foco flutuando
  },
  "& label.MuiInputLabel-shrink": {
    color: "#164194", // label sem foco flutuando
  },
  "& .MuiOutlinedInput-root": {
    "&:hover fieldset": {
      borderColor: "#164194", // borda
    },
    "&.Mui-focused fieldset": {
      borderColor: "#164194", // borda
    },
  },
}));

const e164PhoneMask = (value) => {
  if (!value) {
    return "";
  }
  const digits = String(value).replace(/\D/g, "");
  if (!digits) {
    return "";
  }
  return `+${digits.substring(0, 15)}`;
};

const isValidE164Phone = (value) => {
  const digits = String(value || "").replace(/\D/g, "");
  return digits.length >= 10 && digits.length <= 15;
};

const SIGNATURE_TYPE = [
  { value: "0", label: "Eletrônica" },
  { value: "1", label: "Digital" },
  { value: "2", label: "Eletrônica ou Digital" },
  { value: "3", label: "Digital (Paraguai)" },
];

// TAB PANEL
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {children}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

// TAB PROPERTIES
function TabProperties({
  jsonConfig,
  handleChangeConfigFields,
  handleChangeAutoCompleteConfigFields,
  handleChangeDocumentos,
  handleChangeAssinantes,
  handleChangeAutoCompleteAssinantes,
  addAssinantes,
  removeAssinantes,
  docPagination,
  setDocPagination,
  removeDocumentos,
  handleCheckBoxRemetente,
  classes,
  taskFields,
  businessObject,
}) {
  const title = jsonConfig?.title || "";
  const description = jsonConfig?.description || "";
  const authorName = jsonConfig?.authorName || "";
  const authorEmail = jsonConfig?.authorEmail || "";
  const authorDocument = jsonConfig?.authorDocument || "";
  const documents = jsonConfig?.documents || [];
  const signers = jsonConfig?.signers || [];

  let documentVariables = getDocumentoVariables(taskFields) || [];
  documentVariables = documentVariables.concat(
    getUniqueDocumentServiceFields(businessObject),
  );

  documentVariables = documentVariables
    .filter((value, index, self) => {
      return index === self.findIndex((obj) => obj.id === value.id);
    })
    .map((value) => value.id);

  const formFieldsVariables =
    taskFields?.filter(
      (taskField) =>
        !documentVariables.some((docItem) => docItem === taskField.id),
    ) || [];

  return (
    <>
      <Grid
        item
        xs={12}
        sx={{ height: "29px", marginBottom: "30px", marginTop: "20px" }}
      >
        <Typography variant="h6" style={{ fontWeight: "bold" }}>
          {language.modelerEnvelopeForSignature}
        </Typography>
      </Grid>

      <Grid container size={12} spacing={3} style={{}} wrap="wrap">
        <Grid item size={{ xs: 12, sm: 12, md: 12 }}>
          <Autocomplete
            value={title}
            onChange={(event, value) =>
              handleChangeAutoCompleteConfigFields(event, value, "title")
            }
            onInputChange={handleChangeConfigFields}
            selectOnFocus
            freeSolo
            id="title"
            name="title"
            options={formFieldsVariables}
            getOptionLabel={(formField) => {
              if (typeof formField === "string") {
                return formField;
              }
              return formField?.id || "";
            }}
            renderInput={(params) => (
              <TextFieldAutocompleteStyled
                {...params}
                variant="outlined"
                name="title"
                required
                label={language.modelerNameEnvelope}
              />
            )}
          />
        </Grid>

        <Grid
          item
          size={12}
          sx={{ height: "29px", marginBottom: "30px", marginTop: "40px" }}
        >
          <Typography variant="h6" style={{ fontWeight: "bold" }}>
            {language.modelerDocumentsForSignature}
          </Typography>
        </Grid>

        <Grid item size={12}>
          <Autocomplete
            value={documents}
            onChange={(event, value, reason) => {
              handleChangeDocumentos(event, value, reason);
            }}
            multiple
            id="document-list"
            options={documentVariables}
            getOptionLabel={(fileField) => fileField}
            filterSelectedOptions
            getOptionSelected={(option, value) => option === value}
            renderInput={(params) => (
              <TextFieldAutocompleteStyled
                {...params}
                variant="outlined"
                required
                label={language.modelerSelectProcessDocuments}
              />
            )}
          />
        </Grid>

        <Grid item container size={12} sx={{ marginTop: "15px" }}>
          {documents && documents.length > 0 && (
            <>
              <Grid
                item
                size={12}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                {documents
                  .slice(
                    docPagination.page * docPagination.itemsPerPage,
                    (docPagination.page + 1) * docPagination.itemsPerPage,
                  )
                  .map((doc, index) => (
                    <Box
                      key={doc}
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        width: "100%",
                        gap: "32px",
                      }}
                    >
                      <Box sx={{ width: "100%" }}>
                        <Box
                          sx={{
                            padding: "8px",
                            height: "60px",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Typography
                              variant="body1"
                              fontWeight="400"
                              fontSize="16px"
                            >
                              {doc}
                            </Typography>
                          </Box>
                        </Box>
                        <Divider sx={{ height: "2px" }} />
                      </Box>
                      <IconButton
                        onClick={() => removeDocumentos(index)}
                        variant="outlined"
                        sx={{
                          border: "1px solid",
                          borderRadius: 2,
                          height: "35px",
                          width: "35px",
                        }}
                      >
                        <RemoveIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  ))}
              </Grid>
              <Grid item size={12}>
                <Pagination
                  itemsPerPage={docPagination.itemsPerPage}
                  page={docPagination.page}
                  setPage={(page) =>
                    setDocPagination({ ...docPagination, page })
                  }
                  totalItems={documents?.length}
                />
              </Grid>
            </>
          )}
        </Grid>

        <Grid
          item
          size={12}
          sx={{ height: "29px", marginBottom: "30px", marginTop: "40px" }}
        >
          <Typography variant="h6" style={{ fontWeight: "bold" }}>
            {language.modelerEnvelopeSender}
          </Typography>
        </Grid>
        <Grid container item size={12} sx={{ marginBottom: "20px" }}>
          <Grid
            item
            size={{ xs: 12, sm: 12, md: 5 }}
            sx={{ paddingRight: "12px" }}
          >
            <Autocomplete
              value={authorName}
              onChange={(event, value) =>
                handleChangeAutoCompleteConfigFields(event, value, "authorName")
              }
              onInputChange={handleChangeConfigFields}
              selectOnFocus
              freeSolo
              id="authorName"
              name="authorName"
              options={formFieldsVariables}
              getOptionLabel={(formField) => {
                if (typeof formField === "string") {
                  return formField;
                }
                return formField?.id || "";
              }}
              renderInput={(params) => (
                <TextFieldAutocompleteStyled
                  {...params}
                  variant="outlined"
                  name="authorName"
                  required
                  label={language.fullName}
                />
              )}
            />
          </Grid>
          <Grid
            item
            size={{ xs: 12, sm: 12, md: 3 }}
            sx={{ paddingRight: "12px" }}
          >
            <Autocomplete
              value={authorDocument}
              onChange={(event, value) =>
                handleChangeAutoCompleteConfigFields(
                  event,
                  value,
                  "authorDocument",
                )
              }
              onInputChange={handleChangeConfigFields}
              selectOnFocus
              freeSolo
              id="authorDocument"
              name="authorDocument"
              options={formFieldsVariables}
              getOptionLabel={(formField) => {
                if (typeof formField === "string") {
                  return formField;
                }
                return formField?.id || "";
              }}
              renderInput={(params) => (
                <TextFieldAutocompleteStyled
                  {...params}
                  variant="outlined"
                  name="authorDocument"
                  required
                  label={language.CPF}
                />
              )}
            />
          </Grid>
          <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
            <Autocomplete
              value={authorEmail}
              onChange={(event, value) =>
                handleChangeAutoCompleteConfigFields(
                  event,
                  value,
                  "authorEmail",
                )
              }
              onInputChange={handleChangeConfigFields}
              selectOnFocus
              freeSolo
              id="authorEmail"
              name="authorEmail"
              options={formFieldsVariables}
              getOptionLabel={(formField) => {
                if (typeof formField === "string") {
                  return formField;
                }
                return formField?.id || "";
              }}
              renderInput={(params) => (
                <TextFieldAutocompleteStyled
                  {...params}
                  variant="outlined"
                  name="authorEmail"
                  required
                  label={language.email}
                />
              )}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        sx={{ height: "29px", marginBottom: "20px", marginTop: "45px" }}
      >
        <Grid item size={{ xs: 12, sm: 6, md: 10 }}>
          <Typography variant="h6" style={{ fontWeight: "bold" }}>
            {language.signers}
          </Typography>
        </Grid>
        <Grid
          item
          size={{ xs: 12, sm: 6, md: 2 }}
          justifyContent="center"
          alignItems="center"
          sx={{ display: "flex" }}
        >
          <Button
            fullWidth
            variant="contained"
            size="medium"
            color="primary"
            style={{
              backgroundColor: "#164194",
            }}
            onClick={addAssinantes}
          >
            {`+ ${language.modelerSigner}`}
          </Button>
        </Grid>
      </Grid>

      <Grid container size={12} wrap="wrap" style={{ marginBottom: "20px" }}>
        <Grid item size={{ xs: 12, sm: 6, md: 6 }} sx={{ marginLeft: "0px" }}>
          <FormControlLabel
            sx={{ marginTop: "10px", marginLeft: "0px" }}
            control={
              <Checkbox
                color="primary"
                name="remetenteIsSigner"
                checked={jsonConfig?.remetenteIsSigner || false}
                onChange={handleCheckBoxRemetente}
              />
            }
            label={language.modelerSenderIsSigner}
            labelPlacement="start"
          />
        </Grid>
      </Grid>

      <Grid container size={12} spacing={3} sx={{ height: "56px" }} wrap="wrap">
        {signers && signers.length > 0 ? (
          <>
            {signers.map((s, index) => {
              return (
                <Fragment key={`s${index}_${s.document}`}>
                  <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                    <Autocomplete
                      value={signers[index]?.signerName || ""}
                      onChange={(event, value) =>
                        handleChangeAutoCompleteAssinantes(
                          event,
                          value,
                          index,
                          "signerName",
                        )
                      }
                      onInputChange={(event) =>
                        handleChangeAssinantes(event, index, "signerName")
                      }
                      selectOnFocus
                      freeSolo
                      id={`s${index}_signerName"`}
                      name="signerName"
                      options={formFieldsVariables}
                      getOptionLabel={(formField) => {
                        if (typeof formField === "string") {
                          return formField;
                        }
                        return formField?.id || "";
                      }}
                      renderInput={(params) => (
                        <TextFieldAutocompleteStyled
                          {...params}
                          variant="outlined"
                          name="signerName"
                          required
                          label={language.fullName}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: signers[index]?.signerSignatureType === "3" ? 2 : 3 }}>
                    <Autocomplete
                      value={signers[index]?.signerDocument || ""}
                      onChange={(event, value) =>
                        handleChangeAutoCompleteAssinantes(
                          event,
                          value,
                          index,
                          "signerDocument",
                        )
                      }
                      onInputChange={(event) =>
                        handleChangeAssinantes(event, index, "signerDocument")
                      }
                      selectOnFocus
                      freeSolo
                      id={`s${index}_signerDocument`}
                      name="signerDocument"
                      options={formFieldsVariables}
                      getOptionLabel={(formField) => {
                        if (typeof formField === "string") {
                          return formField;
                        }
                        return formField?.id || "";
                      }}
                      renderInput={(params) => (
                        <TextFieldAutocompleteStyled
                          {...params}
                          variant="outlined"
                          name="signerDocument"
                          required
                          label={language.CPF}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item size={{ xs: 12, sm: 6, md: signers[index]?.signerSignatureType === "3" ? 2 : 3 }}>
                    <Autocomplete
                      value={signers[index]?.signerEmail || ""}
                      onChange={(event, value) =>
                        handleChangeAutoCompleteAssinantes(
                          event,
                          value,
                          index,
                          "signerEmail",
                        )
                      }
                      onInputChange={(event) =>
                        handleChangeAssinantes(event, index, "signerEmail")
                      }
                      selectOnFocus
                      freeSolo
                      id={`s${index}_signerEmail`}
                      name="signerEmail"
                      options={formFieldsVariables}
                      getOptionLabel={(formField) => {
                        if (typeof formField === "string") {
                          return formField;
                        }
                        return formField?.id || "";
                      }}
                      renderInput={(params) => (
                        <TextFieldAutocompleteStyled
                          {...params}
                          variant="outlined"
                          name="signerEmail"
                          required
                          label={language.email}
                        />
                      )}
                    />
                  </Grid>
                  {signers[index]?.signerSignatureType === "3" && (
                    <Grid item size={{ xs: 12, sm: 6, md: 2 }}>
                      <TextFieldAutocompleteStyled
                        fullWidth
                        label={language.phone || "Telefone"}
                        placeholder="+5511999999999"
                        onChange={(event) =>
                          handleChangeAssinantes(
                            event,
                            index,
                            "signerPhoneNumber",
                          )
                        }
                        name="signerPhoneNumber"
                        value={signers[index]?.signerPhoneNumber || ""}
                        variant="outlined"
                        required
                        inputProps={{
                          inputMode: "tel",
                          autoComplete: "tel",
                          maxLength: 16,
                        }}
                      />
                    </Grid>
                  )}
                  <Grid item size={{ xs: 12, sm: 6, md: 2 }}>
                    <Autocomplete
                      value={
                        SIGNATURE_TYPE.find(
                          (item) =>
                            item.value === signers[index]?.signerSignatureType,
                        )?.label || ""
                      }
                      onChange={(event, value) =>
                        handleChangeAutoCompleteAssinantes(
                          event,
                          value,
                          index,
                          "signerSignatureType",
                          "value",
                        )
                      }
                      onInputChange={(event) =>
                        handleChangeAssinantes(
                          event,
                          index,
                          "signerSignatureType",
                        )
                      }
                      selectOnFocus
                      id={`s${index}_signerSignatureType`}
                      name="signerSignatureType"
                      disableClearable
                      options={SIGNATURE_TYPE}
                      getOptionLabel={(model) => {
                        if (typeof model === "string") {
                          return model;
                        }
                        return model?.label || "";
                      }}
                      renderOption={(props, option) => (
                        <li
                          {...props}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <span style={{ marginRight: "10px" }}>
                            {option.label}
                          </span>
                          <DriveFileRenameOutlineIcon fontSize="small" />
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextFieldAutocompleteStyled
                          {...params}
                          variant="outlined"
                          name="signerSignatureType"
                          required
                          label={language.modelerSignatureType}
                          InputProps={{
                            ...params.InputProps,
                            sx: {
                              cursor: "pointer",
                              color: "#164194",
                            },
                            endAdornment: (
                              <InputAdornment position="end">
                                <DriveFileRenameOutlineIcon fontSize="small" />
                              </InputAdornment>
                            ),
                          }}
                          inputProps={{
                            ...params.inputProps,
                            readOnly: true,
                            sx: {
                              cursor: "pointer",
                              color: "#164194",
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid
                    item
                    size={{ xs: 12, sm: 6, md: 1 }}
                    justifyContent="center"
                    alignItems="center"
                    sx={{ display: "flex" }}
                  >
                    <IconButton
                      size="small"
                      color="primary"
                      sx={{
                        borderRadius: "8px",
                        border: "1px solid",
                      }}
                      onClick={(event) => removeAssinantes(event, index)}
                    >
                      <RemoveIcon />
                    </IconButton>
                  </Grid>
                </Fragment>
              );
            })}
          </>
        ) : (
          <Grid
            item
            size={12}
            justifyContent="center"
            alignItems="center"
            sx={{ display: "flex" }}
          >
            <Typography variant="body1" style={{ fontWeight: "400" }}>
              {language.noSignerSelected}
            </Typography>
          </Grid>
        )}
      </Grid>
    </>
  );
}

// CUSTOMIZA AS AÇÔES DO MODAL
function OverrideModalActions(props) {
  const { handleSubmit, handleClose } = props;
  return (
    <DialogActions>
      <ButtonGroup>
        <Button
          variant="outlined"
          size="large"
          color="primary"
          onClick={handleClose}
        >
          {language.cancel}
        </Button>
        <Button
          variant="contained"
          size="large"
          color="primary"
          onClick={handleSubmit}
        >
          {language.save}
        </Button>
      </ButtonGroup>
    </DialogActions>
  );
}

// Componente

function ModelerIntegrarAssinatura({
  saveIntegrarAssinaturaLoteConfig, // modeler
  businessObject,
  element,
  extensionElements,
  bpmnFactory,
  FormComponents,
  inputValues,
  theme, // tema
  classes,
}) {
  const [jsonConfig, setJsonConfig] = useState({
    title: "",
    description: "",
    authorName: "",
    authorEmail: "",
    authorDocument: "",
    documents: [],
    signers: [],
    remetenteIsSigner: false,
  });

  const [state, setState] = useState({
    fullWidth: true,
    maxWidth: "xl",
    tabValue: 0,
    folderSelected: [],
    currentFolderSelected: false,
  });

  const [hasConfigError, setHasConfigError] = useState(false);

  const [open, setOpen] = useState(true);
  const [docPagination, setDocPagination] = useState({
    itemsPerPage: 4,
    page: 0,
  });

  // EFFECT 1 - preenche o state com os dados do modeler
  useEffect(() => {
    if (inputValues) {
      setJsonConfig({
        title: inputValues?.title,
        description:
          inputValues?.description && unescape(inputValues.description),
        authorName: inputValues?.authorName,
        authorEmail: inputValues?.authorEmail,
        authorDocument: inputValues?.authorDocument,
        documents: inputValues?.documents,
        signers:
          inputValues?.signers?.map((s) => {
            return {
              signerName: s.name,
              signerEmail: s.email,
              signerDocument: s.document,
              signerPhoneNumber: s.phoneNumber
                ? e164PhoneMask(s.phoneNumber)
                : "",
              signerSignatureType: s.signatureType,
            };
          }) || [],
        remetenteIsSigner: inputValues?.remetenteIsSigner,
      });
    }
  }, [inputValues]);

  const handleClose = () => {
    setOpen(false);
  };

  //gerencia state das abas
  const handleChangeTab = (event, newValue) => {
    setState((prev) => ({
      ...prev,
      tabValue: newValue,
    }));
  };

  const validateConfig = (obj) => {
    const erros = [];

    if (!obj.title) {
      erros.push(language.signatureTitleRequired);
    }

    if (!obj.authorName) {
      erros.push(language.signatureResponsibleNameRequired);
    }

    if (!obj.authorEmail) {
      erros.push(language.signatureResponsibleEmailRequired);
    }

    if (!obj.authorDocument) {
      erros.push(language.signatureResponsibleCpfRequired);
    }

    if (!obj.documents || obj.documents.length <= 0) {
      erros.push(language.signatureDocumentToBeSignedRequired);
    }

    if (!obj.signers || obj.signers.length <= 0) {
      erros.push(language.signersRequired);
    }

    if (obj.signers?.length) {
      if (
        obj.signers.filter(
          (s) =>
            !s.name ||
            !s.email ||
            !s.document ||
            !s.signatureType ||
            (s.signatureType === "3" && !isValidE164Phone(s.phoneNumber)),
        ).length > 0
      ) {
        erros.push(language.fillOrRemoveEmptySigners);
      }
    }

    return erros;
  };

  const handleSave = () => {
    const title = jsonConfig?.title;
    const description =
      jsonConfig?.description && escape(jsonConfig.description);
    const authorName = jsonConfig?.authorName;
    const authorEmail = jsonConfig?.authorEmail;
    const authorDocument = jsonConfig?.authorDocument;
    const documents = jsonConfig?.documents || [];
    let signers = jsonConfig?.signers || [];
    const remetenteIsSigner = jsonConfig?.remetenteIsSigner;

    signers = signers.map((s) => {
      return {
        name: s.signerName,
        email: s.signerEmail,
        document: s.signerDocument,
        phoneNumber: s.signerPhoneNumber,
        signatureType: s.signerSignatureType,
      };
    });

    const inputObject = {
      title,
      description,
      authorName,
      authorEmail,
      authorDocument,
      documents,
      signers,
      remetenteIsSigner,
    };

    const erros = validateConfig(inputObject);

    if (erros.length > 0) {
      setHasConfigError(erros);
    } else {
      //salvando no modeler
      saveIntegrarAssinaturaLoteConfig(
        businessObject,
        element,
        extensionElements,
        bpmnFactory,
        inputObject,
      );

      handleClose();
    }
  };

  const handleChangeConfigFields = (event) => {
    if (!event?.target) return;

    const { name, value } = event.target;
    setJsonConfig((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeAutoCompleteConfigFields = (event, value, name) => {
    if (!event?.target) return;

    let newValue;
    if (typeof value === "string") {
      newValue = value;
    } else if (value?.id) {
      newValue = value.id;
    } else {
      newValue = value;
    }

    setJsonConfig((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleChangeDocumentos = (event, newValue, selectedOption) => {
    setJsonConfig((prev) => ({
      ...prev,
      documents: newValue,
    }));
  };

  const removeDocumentos = (docIndex) => {
    const arrayValue = jsonConfig?.documents || [];
    arrayValue.splice(docIndex, 1);

    setJsonConfig((prev) => ({
      ...prev,
      documents: arrayValue,
    }));
  };

  const handleChangeAssinantes = (event, index, name) => {
    if (!event?.target) return;

    const { value } = event.target;
    const signers = jsonConfig?.signers || [];

    signers[index] = {
      ...signers[index],
      [name]: name === "signerPhoneNumber" ? e164PhoneMask(value) : value,
    };

    setJsonConfig((prev) => ({
      ...prev,
      signers,
    }));
  };

  const handleChangeAutoCompleteAssinantes = (
    event,
    value,
    index,
    name,
    attributeField,
  ) => {
    if (!event?.target) return;

    const signers = jsonConfig?.signers || [];

    let newValue;
    if (typeof value === "string") {
      newValue = value;
    } else if (value?.id) {
      newValue = value.id;
    } else if (attributeField && value?.[attributeField]) {
      newValue = value[attributeField];
    } else {
      newValue = value;
    }

    let updatedSigners = [...signers];
    if (name === "signerSignatureType") {
      if (newValue === "3") {
        updatedSigners = updatedSigners.map((s) => ({
          ...s,
          signerSignatureType: "3",
        }));
      } else {
        const hasType3 = updatedSigners.some(
          (s) => s.signerSignatureType === "3",
        );
        if (hasType3) {
          updatedSigners = updatedSigners.map((s) => ({
            ...s,
            signerSignatureType: newValue,
          }));
        } else {
          updatedSigners[index] = {
            ...updatedSigners[index],
            [name]: newValue,
          };
        }
      }
    } else {
      updatedSigners[index] = {
        ...updatedSigners[index],
        [name]: newValue,
      };
    }

    setJsonConfig((prev) => ({
      ...prev,
      signers: updatedSigners,
    }));
  };

  const addAssinantes = () => {
    const signers = jsonConfig?.signers || [];

    const isAnyType3 = signers.some((s) => s.signerSignatureType === "3");

    signers.push({
      signerName: "",
      signerEmail: "",
      signerDocument: "",
      signerPhoneNumber: "",
      signerSignatureType: isAnyType3 ? "3" : "0",
    });

    setJsonConfig((prev) => ({
      ...prev,
      signers,
    }));
  };

  const removeAssinantes = (event, index) => {
    const signers = jsonConfig?.signers || [];

    signers.splice(index, 1);

    setJsonConfig((prev) => ({
      ...prev,
      signers,
    }));
  };

  const handleCheckBoxRemetente = (event) => {
    const { name, value, checked } = event.target;

    const remetenteName = jsonConfig?.authorName;
    const remetenteDoc = jsonConfig?.authorDocument;
    const remetenteEmail = jsonConfig?.authorEmail;

    const signers = jsonConfig?.signers || [];

    if (remetenteName && remetenteDoc && remetenteEmail) {
      const existentAuthorIndex = signers.findIndex((s) => {
        return (
          s?.signerName === remetenteName &&
          s?.signerDocument === remetenteDoc &&
          s?.signerEmail === remetenteEmail
        );
      });

      // adicionando
      if (checked && existentAuthorIndex === -1) {
        const isAnyType3 = signers.some((s) => s.signerSignatureType === "3");
        signers.push({
          signerName: remetenteName,
          signerEmail: remetenteEmail,
          signerDocument: remetenteDoc,
          signerPhoneNumber: "",
          signerSignatureType: isAnyType3 ? "3" : "0",
        });
      }

      // removendo
      if (!checked && existentAuthorIndex !== -1) {
        signers.splice(existentAuthorIndex, 1);
      }
    }

    setJsonConfig((prev) => ({
      ...prev,
      signers,
      remetenteIsSigner: checked,
    }));
  };

  const { tabValue } = state;

  return (
    open && (
      <GenericModal
        title={language.configuration}
        handleClose={handleClose}
        size={state.maxWidth}
        open={true}
        handleSubmit={handleSave}
        btnActionTitle={language.save}
        btnCancelTitle={language.cancel}
        overrideDialogActions={() =>
          OverrideModalActions({
            handleSubmit: handleSave,
            handleClose,
          })
        }
      >
        <div style={{ height: "75vh" }}>
          <Grid container direction="row">
            <Grid item xs={12}>
              <Tabs
                value={tabValue}
                indicatorColor="secondary"
                textColor="secondary"
                onChange={handleChangeTab}
              >
                <Tab label={language.properties} />
                <Tab label={language.configuration} disabled />
                <Tab label={language.permissions} disabled />
              </Tabs>
            </Grid>

            <Grid item size={12} sx={{ padding: "1% 1%" }}>
              <TabPanel value={tabValue} index={0}>
                <TabProperties
                  businessObject={businessObject}
                  taskFields={FormComponents}
                  classes={classes}
                  jsonConfig={jsonConfig}
                  handleChangeConfigFields={handleChangeConfigFields}
                  handleChangeAutoCompleteConfigFields={
                    handleChangeAutoCompleteConfigFields
                  }
                  handleChangeDocumentos={handleChangeDocumentos}
                  handleChangeAssinantes={handleChangeAssinantes}
                  handleChangeAutoCompleteAssinantes={
                    handleChangeAutoCompleteAssinantes
                  }
                  addAssinantes={addAssinantes}
                  removeAssinantes={removeAssinantes}
                  docPagination={docPagination}
                  setDocPagination={setDocPagination}
                  removeDocumentos={removeDocumentos}
                  handleCheckBoxRemetente={handleCheckBoxRemetente}
                />
              </TabPanel>
            </Grid>
          </Grid>

          {hasConfigError && (
            <GenericSnackbar
              errorWithChildren={true}
              message={
                <div>
                  {hasConfigError.map((err, index) => {
                    return <div key={`errorMessage_${index}`}>{err}</div>;
                  })}
                </div>
              }
              handleClose={() => setHasConfigError(false)}
              duration={4000}
            />
          )}
        </div>
      </GenericModal>
    )
  );
}

export default ModelerIntegrarAssinatura;
